<template>
  <div class="flex w-full" style="position: relative">
    <div v-if="gliders.length" class="d-flex flex-col w-full h-full">
      <div class="flex-grow-0 w-full">
        <v-tabs v-model="selectedGliderIdx" align-with-title class="flex-grow-0">
          <v-tab>
            <v-icon class="mr-2 !text-black">{{ fleetIco }}</v-icon>
            {{ fleet.FLE_LIBELLE }}
          </v-tab>
          <v-tab v-for="(glider, idx) in gliders" :key="glider.id" :title="glider.libelle">
            {{ glider.libelle }}
          </v-tab>
        </v-tabs>
      </div>
      <div class="flex flex-col" v-if="selectedGliderIdx == 0">
        <fleet-detail-rsync :fleet="fleet" />
        <fleet-detail-ftp :fleet="fleet" />
      </div>
      <mission-detail-ftp-rsync
        v-else
        :uiid="uiid"
        :isleft="isleft"
        :mission="store.myGetters.missionsById[gliders[selectedGliderIdx - 1].id]"
        :isVisible="props.isVisible"
        :key="selectedGliderIdx"
      />
    </div>
    <div v-else class="w-full h-full flex flex-col mx-4 items-center justify-center title gap-2">
      <span>{{ $t('Fleet.NoGliders') }}</span>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue'
import store from '@/store'
import { AloDbFleet, isAloDbFleetCoverage, isAloDbFleetFormation } from '@/models/alodb/AloDbFleet'
import MissionDetailFtpRsync from '@/components/mission/MissionDetailFtpRsync.vue'
import FleetDetailRsync from '@/components/fleet/FleetDetailRsync.vue'
import FleetDetailFtp from '@/components/fleet/FleetDetailFtp.vue'

const props = defineProps<{
  fleet: AloDbFleet
  isleft: boolean
  uiid: string
  isVisible: boolean
}>()

const fleetIco = computed(() => {
  return isAloDbFleetCoverage(props.fleet)
    ? 'mdi-select-group'
    : isAloDbFleetFormation(props.fleet)
    ? 'mdi-vector-circle'
    : 'mdi-multicast'
})

const missions = computed(
  () => props.fleet.activeMissionIds?.map((id) => store.myGetters?.missionsById[id])?.filter((m) => !!m) ?? []
)

const gliders = computed(() => missions.value.map((m) => ({ id: m.misId, libelle: m.gliKey })))

const selectedGliderIdx = ref(0)
</script>
